export enum DATE_PICKER_TOGGLE {
	date = 'DATE',
	period = 'PERIOD',
}
